module.exports = __webpack_public_path__ + "static/media/portfolio-v1-min.b0e0d637.png";